import get from 'lodash/get';

import { createMessage } from 'app/modules/messages/actions/createMessage';
import { createMessagePending } from 'app/modules/messages/actions/createMessagePending';
import { createEmptyUser } from 'app/modules/user/actions/createUser';
import checkAuth from 'app/modules/user/actions/checkAuth';

const authOrCreateMessage = record => {
  return (dispatch, getState) => {
    let state = getState();
    let user = state.user;
    let appState = state.app;
    let userId = get(user, 'id');

    if (userId && appState.clientReady) {
      dispatch(createMessage(record));
    } else {
      dispatch(createMessagePending(record));
      //dont keep creating users if we already did
      if (!userId) {
        dispatch(createEmptyUser());
        dispatch(checkAuth());
      }
    }
  };
};

export default authOrCreateMessage;
